// Environment configuration utility
// Note: Vite uses VITE_ prefix instead of REACT_APP_
// For backward compatibility, we support both during migration
export const env = {
  version: import.meta.env.VITE_VERSION || process.env.REACT_APP_VERSION || '1.0.0',
  environment: import.meta.env.VITE_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT || 'development',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
  enableAnalytics: (import.meta.env.VITE_ENABLE_ANALYTICS || process.env.REACT_APP_ENABLE_ANALYTICS) === 'true',
};

export const isDevelopment = env.environment === 'development';
export const isProduction = env.environment === 'production';

// API configuration
export const apiConfig = {
  baseUrl: env.apiBaseUrl,
  timeout: 10000,
  retries: 3,
};

console.log('Environment loaded:', {
  version: env.version,
  environment: env.environment,
  enableAnalytics: env.enableAnalytics,
});
